import { render, staticRenderFns } from "./CourseRecList.vue?vue&type=template&id=6094838e&scoped=true&"
import script from "./CourseRecList.vue?vue&type=script&lang=js&"
export * from "./CourseRecList.vue?vue&type=script&lang=js&"
import style0 from "./CourseRecList.vue?vue&type=style&index=0&id=6094838e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094838e",
  null
  
)

export default component.exports